import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import theme from './js/stores/theme.js';
import language from './js/stores/language.js';
import user from './js/stores/user.js';
import contact from './js/stores/contact.js';
import carLoanItemLibrary from './js/controllers/car-loan-item-lib.js';
function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
    $ = _ref.$,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted;
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div id="app" class="dark">

    <!-- Your main view, should have "view-main" class -->
    <div class="view view-main view-init safe-areas" data-url="/"></div>

  </div>
`
    }
    ;
}
framework7Component.id = '4f88864589';
export default framework7Component;